import { Stack, IconButton, Box, FormLabel } from "@chakra-ui/react";
import ButtonUI from "../../../ButtonUI";
import { FieldInput } from "../../Elements/FieldInput";
import { DeleteIcon } from "@chakra-ui/icons";
import { useRepeater } from "../../../../hooks/FormGeneratorHooks/useRepeater";
import { useTranslation } from "react-i18next";

const DEFAULT_VALUES = {
  collection: [{ label: "Default label" }],
};

export const Repeater = (props) => {
  const { t } = useTranslation() as any;
  const collection = useRepeater({
    name: "options",
    form: props.form,
    initialValues: props.value,
  });

  return (
    <Stack
      justifyContent={"flex-start "}
      spacing={2}
      align="start"
      className="border p-4 rounded-lg w-full mb-6 "
    >
      <FormLabel>
        {" "}
        <span style={{ fontSize: "16px" }} className="font-bold ">
          {t("Survey.Choice")}
        </span>
      </FormLabel>
      <Box>
        {collection.keys.map((key, index) => (
          <Stack
            key={key}
            direction="row"
            spacing="4"
            mb="6"
            data-test={`repeater-item[${index}]`}
          >
            <Box flex="1">
              <FieldInput
                value={props.value[index]?.label}
                name={`options[${index}].label`}
                defaultValue={DEFAULT_VALUES.collection[index]?.label}
                label={`${"Choix " + (index + 1)}`}
                required={t("Survey.RequireField")}
                m="0"
              />
            </Box>

            <Box pt="1.75rem">
              <IconButton
                aria-label="Delete"
                icon={
                  <DeleteIcon
                    className="
                    w-10 h-10"
                  />
                }
                onClick={() => collection.remove(index)}
              />
            </Box>
          </Stack>
        ))}
      </Box>

      <Box>
        {collection.length <= 20 && (
          <ButtonUI
            status="secondary"
            className="p-2 text-xs w-48"
            type="button"
            onClick={() => collection.append()}
          >
            {" "}
            {t("Survey.AddChoice")}{" "}
          </ButtonUI>
        )}
      </Box>
    </Stack>
  );
};
